import React from 'react';
import PageHeadingSection from '../../../../common/pageheading/PageHeadingSection';
import SectionTab from '../../../../common/sectiontab/SectionTab';
import Breadcrumbs from '../../../../common/BreadCrum/BreadCrum';

import PendingRequests from './components/PendingRequests';
import ActiveVisitors from './components/ActiveVisitors';
import UpcomingPreApproved from './components/UpcomingPreApproved';

const PayAndPark = () => {
    // Dummy Data
    const parkingSlots = [
        { id: 'P2-V018', name: 'Rajesh Patel', status: 'Occupied' },
        { id: 'P2-V019', name: 'Amit Shah', status: 'Occupied' },
        { id: 'P2-V020', name: 'Ready for Guest', status: 'Available' },
        { id: 'P2-V021', name: 'Ready for Guest', status: 'Available' }
    ];

    // The separate components (PendingRequests, ActiveVisitors, UpcomingPreApproved) are now imported.

    const tabs = [
        { key: 'pending', label: 'Pending Gate Requests (5)', component: PendingRequests },
        { key: 'active', label: 'Active Visitors (5)', component: ActiveVisitors },
        { key: 'upcoming', label: 'Upcoming Pre-Approved (5)', component: UpcomingPreApproved }
    ];

    return (
        <div className="bg-dashboardbg px-6 py-4 border border-bordercolor flex flex-col rounded-lg flex-1 overflow-y-auto pt-4">
            <Breadcrumbs />
            <PageHeadingSection
                Navbar={true}
                mainHeading="Visitor Parking Management"
                subHeading="Review security gate visitor requests, allocate guest slots, and pre-approve client passes"
            />

            {/* Capacity Card */}
            <div className="mt-6 bg-white border border-bordercolor rounded-xl p-5 shadow-sm">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-5">
                    <div>
                        <h2 className="text-xs font-bold text-gray-900">Visitor Parking Capacity (4 Slots Allocated)</h2>
                        <p className="text-[11px] text-gray-500 mt-1">Real-time status of designated guest parking bays on Floor P2</p>
                    </div>
                    <div className="flex items-center gap-2 bg-[#ECFDF5] border border-[#A7F3D0] rounded-full px-4 py-1.5 shadow-sm self-start md:self-auto">
                        <span className="text-[10px] font-bold text-[#059669]">2 Available</span>
                        <span className="text-[#059669]">•</span>
                        <span className="text-[10px] font-bold text-[#DC2626]">2 Occupied</span>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    {parkingSlots.map(slot => (
                        <div key={slot.id} className={`p-4 rounded-xl border ${slot.status === 'Occupied' ? 'bg-gray-50 border-gray-200' : 'bg-[#F0FDF4] border-[#BBF7D0]'}`}>
                            <div className="flex justify-between items-start mb-3">
                                <span className="text-[9px] font-bold text-gray-400 uppercase tracking-widest">Slot</span>
                                <span className={`text-[9px] font-bold px-2.5 py-1 rounded-full flex items-center gap-1.5 shadow-sm ${slot.status === 'Occupied' ? 'bg-blue-100 text-blue-700' : 'bg-[#059669] text-white'}`}>
                                    <div className={`w-1 h-1 rounded-full ${slot.status === 'Occupied' ? 'bg-blue-600' : 'bg-white'}`}></div>
                                    {slot.status}
                                </span>
                            </div>
                            <h3 className="text-sm font-bold text-gray-900">{slot.id}</h3>
                            <p className={`text-[11px] mt-1 font-medium ${slot.status === 'Available' ? 'text-[#059669]' : 'text-gray-500'}`}>{slot.name}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Tabs */}
            <div className="mt-2">
                <SectionTab tabs={tabs} defaultTab="active" />
            </div>
        </div>
    );
};

export default PayAndPark;
